import React from 'react';
export const Select = props => {
  const {
    param,
    data
  } = props;
  return <div>{!data[param.key] || data[param.key] === '' ? <em>No value specified</em> : param.options[data[param.key]]}</div>;
};